export default "__VITE_ASSET__CaQspDGB__"